import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2Button } from 'components/mapV2/elements/MapV2Button';
import { useActions } from 'components/mapV2/hooks/useActions';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { Localization } from 'static/localization/localization';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MapV2ModalDetailHeader = (props: Props): JSX.Element => {
    const actions = useActions();
    const ctxMapV2 = useContext(CtxMapV2);
    const ctxModal = useContext(CtxModal);
    const isWide = ctxMapV2.isWide;

    const headerBackgroundColor = ctxMapV2.isWide ? '#fff' : 'unset';

    return (
        <S_MapV2ModalDetailHeader
            className={props.className}
            $bgColor={headerBackgroundColor}
            $isWide={isWide}
        >
            {ctxMapV2.features.isListEnabled || ctxModal.detailListModal ? (
                <S_MapV2Button
                    label={Localization.MAP_V2_GO_BACK}
                    icon={{ prefix: 'fas', iconName: 'caret-left' }}
                    onClick={actions.returnToList}
                    type={'light'}
                />
            ) : (
                <div />
            )}
            <S_MapV2Button
                icon={{ prefix: 'far', iconName: 'xmark' }}
                type={'light'}
                onClick={actions.closeModal}
                style={{
                    width: 34,
                    height: 34
                }}
            />
        </S_MapV2ModalDetailHeader>
    );
};

const S_MapV2ModalDetailHeader = styled.div<{ $bgColor: string; $isWide: boolean }>`
    background: ${(props) => props.$bgColor};
    display: flex;
    flex-direction: row;
    padding: 7px 20px 7px 20px;
    align-items: center;
    justify-content: space-between;
    ${(props) => {
        if (props.$isWide) {
            return css`
                box-shadow: 1px 1px 8px rgba(0, 0, 0, 1);
            `;
        }
    }}
`;

const S_MapV2Button = styled(MapV2Button)`
    padding: 8px 12px;
`;
